import React from 'react'

import {
  SVGOkoslista
} from "Components/SVGCollection";

import cn from 'classnames'
import cg from 'Scss/app.scss'
import cl from '../../ProfileNavListItem/ProfileNavListItem.scss'
import csl from '../ShoppingList.scss'
import btnCss from 'Components/Button/Button.scss'
import { ListType } from 'Utils/api/ListClient';
import Button from 'Components/Button';

type PropType = {
  list: ShoppingList.IShoppingList
  onAcceptShare?: (list: ShoppingList.IShoppingList) => void
  onDeclineShare?: (list: ShoppingList.IShoppingList) => void
}

export default class SharedListItem extends React.Component<PropType> {

  onAcceptShare = () => {
    this.props.onAcceptShare && this.props.onAcceptShare(this.props.list)
  }

  onDeclineShare = () => {
    this.props.onDeclineShare && this.props.onDeclineShare(this.props.list)
  }

  render() {
    return (
      <div className={cn(cl.profileNav__listItem, csl.profileNav__listItem)}>
        <div className={cn(cg.gridX, cg.alignMiddle, cl.listItem__gridX)}>
          {this.props.list.type === ListType.SmartList && (
            <div className={cn(cg.cell, cg.shrink, cl.cell, cl.shrink, cl.smartListIcon)}>
              <SVGOkoslista width={24} height={24} title={'A listát az Okoslista alkalmazásodban is megtalálod'} /> 
            </div>
          )}
          <div className={cn(cg.cell, cg.auto, cl.cell, cl.auto)}>
            <span className={cl.listItem__link}>
              {this.props.list.name}
            </span>
          </div>

          <div className={cn(cg.cell, cg.shrink, cl.cell, cl.shrink)} style={{paddingLeft: '5px', paddingRight: '5px'}}>
            <Button label={'Elutasítás'} className={cn(btnCss.small, btnCss.hollow)} onClick={this.onDeclineShare} style={{margin: '0'}}/>
          </div>

          <div className={cn(cg.cell, cg.shrink, cl.cell, cl.shrink)} style={{paddingLeft: '5px', paddingRight: '10px'}}>
            <Button label={'Csatlakozás'} className={cn(btnCss.small, btnCss.secondary)} onClick={this.onAcceptShare} style={{margin: '0'}}/>
          </div>

        </div>
      </div>
    )
  }
}